import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-wizard',
  templateUrl: './wizard.component.html',
  styleUrls: ['./wizard.component.scss']
})

export class WizardComponent implements OnInit {
  @Input() activeStep: number;
  @Input() stepsList: any[];
  @Input() variation: boolean;

  @Output() stepChanged = new EventEmitter<number>();

  constructor() {}
  ngOnInit() {}

  changeStep(num: number) {
    this.stepChanged.emit(this.activeStep);
  }
}
